import { AFFILIATE_PROGRAM_SETTINGS_API } from 'modules/profile/affiliate-program-settings/api/affiliate-program-settings-api'
import {
  AffiliateProgramLinksApiInterface,
  AffiliateProgramPaymentInterface,
  AffiliateProgramSettingsInterface,
} from 'modules/profile/affiliate-program-settings/types/affiliate-program-settings-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import useSWR from 'swr'

export function useAffiliateProgramSettings({ pagination, limit }: SwrPaginationInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, any>({
    method: RequestMethodsEnum.get,
  })

  const { data: affiliateProgram, mutate: mutateAffiliateProgram } =
    useSWR<AffiliateProgramSettingsInterface>(() => {
      if (user) {
        return `${AFFILIATE_PROGRAM_SETTINGS_API}/program`
      }
      return null
    }, fetcher)
  const { data: affiliateProgramPayment, mutate: mutatePayment } =
    useSWR<AffiliateProgramPaymentInterface>(() => {
      if (user) {
        return `${AFFILIATE_PROGRAM_SETTINGS_API}/payment`
      }
      return null
    }, fetcher)
  const { data: affiliateProgramLinks, mutate: mutateLinks } =
    useSWR<AffiliateProgramLinksApiInterface>(() => {
      if (user && pagination.startFromId === undefined && limit) {
        return `${AFFILIATE_PROGRAM_SETTINGS_API}/links?pagination[limit]=${limit}`
      } else if (user && pagination.startFromId && limit) {
        return `${AFFILIATE_PROGRAM_SETTINGS_API}/links?pagination[startFrom]=${pagination.startFromId}&pagination[order]=${pagination.order}&pagination[limit]=${limit}`
      }
      return null
    }, fetcher)
  return {
    affiliateProgram,
    mutateAffiliateProgram,
    affiliateProgramPayment,
    mutatePayment,
    affiliateProgramLinks,
    mutateLinks,
  }
}
